import React from "react";

import * as Styled from "./buttons.style";

export const Buttons = ({ children, noMargin }) => (
  <Styled.Buttons noMargin={noMargin}>{children}</Styled.Buttons>
);

export default Buttons;
